import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-fit h-9 bg-white rounded-md py-2 text-md font-semibold flex items-center justify-center gap-2 cursor-pointer", _ctx.$props.iconOnly ? 'px-2' : 'px-4'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}